import { Record } from "immutable";

import createFromJS from "../../../createFromJS";
import Precision from "../../../datePrecision";

export const DateRecord = Record(
  {
    era: null,
    year: null,
    month: null,
    day: null,
    hour: null,
    minute: null,
    second: null,
    timestamp: null,
    weekday: null,
    precision: Precision.Auto
  },
  "DateRecord"
);

createFromJS.registerCallback("DateRecord", createFromJS.createPrimitiveCallback(DateRecord));
